import { SortingState } from "@tanstack/react-table";

/**
 * Hydrate TanStack sorting from URL query params.
 * Absent sort falls back to the table's default sorting.
 */
export function sortingFromSearchParams(
  sort: string | undefined,
  dir: string | undefined,
  defaultSorting: SortingState = [],
): SortingState {
  if (!sort) {
    return defaultSorting;
  }

  return [{ id: sort, desc: dir === "desc" }];
}

/**
 * Serialize TanStack sorting into URL query params.
 * Empty sorting omits both keys so the default applies on load.
 */
export function sortingToSearchParams(sorting: SortingState): {
  sort: string | undefined;
  dir: string | undefined;
} {
  const first = sorting[0];
  if (!first) {
    return { sort: undefined, dir: undefined };
  }

  return {
    sort: first.id,
    dir: first.desc ? "desc" : "asc",
  };
}
